<template>
  <v-card
    outlined
    class="dashboard-stat-card"
    :class="{ 'dashboard-stat-card--clickable': !!to }"
    @click="goTo"
  >
    <v-card-text class="pa-4">
      <div class="d-flex align-start justify-space-between">
        <div>
          <div class="stat-title">{{ title }}</div>
          <div class="stat-subtitle" v-if="subtitle">{{ subtitle }}</div>
        </div>

        <v-avatar :color="color" size="42" class="stat-icon">
          <v-icon dark>{{ icon }}</v-icon>
        </v-avatar>
      </div>

      <div class="mt-5">
        <v-skeleton-loader
          v-if="loading"
          type="text"
          class="stat-loader"
        />

        <div v-else class="stat-value">
          <slot>
            {{ value }}
          </slot>
        </div>
      </div>

      <div v-if="footer" class="stat-footer mt-2">
        {{ footer }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "DashboardStatCard",

  props: {
    title: String,
    subtitle: String,
    value: [String, Number],
    footer: String,
    icon: {
      type: String,
      default: "mdi-chart-box-outline",
    },
    color: {
      type: String,
      default: "primary",
    },
    loading: Boolean,
    to: String,
  },

  methods: {
    goTo() {
      if (this.to) {
        this.$router.push({ path: this.to });
      }
    },
  },
};
</script>

<style scoped>
.dashboard-stat-card {
  border-radius: 20px;
  min-height: 150px;
  transition: all 0.2s ease;
  background: #ffffff;
}

.dashboard-stat-card--clickable {
  cursor: pointer;
}

.dashboard-stat-card--clickable:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.08);
}

.stat-title {
  font-size: 14px;
  font-weight: 600;
  color: #475569;
}

.stat-subtitle {
  font-size: 12px;
  color: #94a3b8;
  margin-top: 2px;
}

.stat-icon {
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.12);
}

.stat-value {
  font-size: 34px;
  line-height: 1.1;
  font-weight: 700;
  color: #0f172a;
}

.stat-footer {
  font-size: 12px;
  color: #64748b;
}

.stat-loader {
  max-width: 120px;
}
</style>